import "../../css/list.css"

interface OverlayIconProps {
  title: string;
  onClick?: () => void;
  className?: string;
}

const OverlayIcon = ({ title, onClick, className }: OverlayIconProps) => (
  <span className={`icon-overlay border border-dark text-dark rounded-pill px-1 small mouse-pointer ${className ?? ""}`}
        role="img"
        aria-label={title}
        onClick={onClick}
  >
    {title}
  </span>
);

export default OverlayIcon;